import React from 'react';
import { getContext } from 'common';
import _merge from 'lodash/merge';
import Styled from './styles';

export interface CoachmarkContentProps extends React.ComponentPropsWithRef<'div'> {
  /** Content is placed here. */
  children: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** Coachmark content.
 * All additional props will be forwarded to the root element.
 * */
const CoachmarkContent = React.forwardRef<HTMLElement, CoachmarkContentProps>((props: CoachmarkContentProps, ref) =>
  getContext(({ RTL, theme: globalTheme }) => {
    const { children, theme, ...otherProps } = props;
    const resolvedTheme = _merge({}, globalTheme.COACHMARKS, theme);
    return (
      <Styled.CoachmarkContent $rtl={RTL} ref={ref} $theme={resolvedTheme} {...otherProps}>
        {children}
      </Styled.CoachmarkContent>
    );
  }));

CoachmarkContent.displayName = 'CoachmarkContent';
CoachmarkContent.defaultProps = {
  theme: {}
};

/* Exports */
export { CoachmarkContent as default };
